function setCookie(name, value, days) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; SameSite=None; Secure`;
}

function getCookie(name) {
  const cookieString = `; ${document.cookie}`;
  const cookies = cookieString.split(`; ${name}=`);
  if (cookies.length === 2) {
    return cookies.pop().split(';').shift();
  }
  return null;
}

/* global Modal */
if (!customElements.get('pop-up')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class PopUp extends Modal {
      constructor() {
        super();
        this.cookie = `${this.id}-dismissed`;
        if (Shopify.designMode) {
          document.addEventListener('shopify:section:select', (evt) => {
            if (evt.target === this.closest('.shopify-section')) this.open();
          });
          document.addEventListener('shopify:section:deselect', this.close.bind(this));
        } else if (!getCookie(this.cookie) && (this.dataset.showOnMobile === 'true'
          || theme.mediaMatches.md)) {
          if (this.querySelector('.alert')) {
            this.open();
          } else if (this.dataset.trigger === 'delay') {
  setTimeout(() => {
    const navOpen = document.querySelector('#main-nav[open], .mobile-navigation-drawer[open]');
    if (!navOpen) this.open();
  }, Number(this.dataset.delay) * 1000);
          } else if (this.dataset.trigger === 'exit' && theme.mediaMatches.md) {
            this.mouseLeaveHandler = this.mouseLeaveHandler || this.handleMouseLeave.bind(this);
            document.body.addEventListener('mouseleave', this.mouseLeaveHandler);
          }
        }
      }

      disconnectedCallback() {
        if (this.mouseLeaveHandler) {
          document.body.removeEventListener('mouseleave', this.mouseLeaveHandler);
        }
      }

      handleMouseLeave(evt) {
        if (evt.clientY < 0 && !getCookie(this.cookie)) this.open();
      }

      open(opener) {
        // Restore window before opening so animation can play
        const win = this.querySelector('.modal__window');
        if (win) {
          win.style.display = '';
          win.style.pointerEvents = 'auto';
          win.style.visibility = '';
        }

        super.open(opener);
        this.style.backgroundColor = 'transparent';
        this.style.pointerEvents = 'none';

        requestAnimationFrame(() => {
          document.documentElement.style.overflow = 'auto';
          document.body.style.overflow = 'auto';
          document.documentElement.style.height = 'auto';
          document.body.style.height = 'auto';

          const overlay = document.querySelector('.js-overlay');
          if (overlay) {
            overlay.style.display = 'none';
            overlay.style.pointerEvents = 'none';
          }

          const shade = document.querySelector('.page-shade');
          if (shade) {
            shade.style.display = 'none';
            shade.style.pointerEvents = 'none';
          }
        });
      }

      close() {
        super.close();
        this.style.backgroundColor = '';
        this.style.pointerEvents = 'none';

        // Wait for close animation to finish then remove from rendering tree
        const win = this.querySelector('.modal__window');
        if (win) {
          win.style.pointerEvents = 'none';
          setTimeout(() => {
            win.style.display = 'none';
          }, 500);
        }

        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.documentElement.style.height = '';
        document.body.style.height = '';

        const overlay = document.querySelector('.js-overlay');
        if (overlay) {
          overlay.style.display = '';
          overlay.style.pointerEvents = '';
        }

        const shade = document.querySelector('.page-shade');
        if (shade) {
          shade.style.display = '';
          shade.style.pointerEvents = '';
        }

        setCookie(this.cookie, true, parseInt(this.dataset.dismissDays, 10));
      }
    }

    customElements.define('pop-up', PopUp);
  });
}